import React, { Component } from 'react';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';

import axios from 'axios';
import { ROOT_API_URL } from '../../../../../api-config';
import _ from 'lodash';

import PlacesAutocomplete, {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
} from 'react-places-autocomplete';

class UserMembershipForm extends Component {
    constructor(props) {
        super(props);
        //let t = { ...this.props.dataItem };
        //t.state = {
        //    id: t.StateId,
        //    name: t.State
        //}

        this.props.dataItem.StateObj = {
            id: this.props.dataItem.StateId || 44,
            name: this.props.dataItem.State || 'TX',
        };
        this.state = {
            membershipUserInEdit: this.props.dataItem,
            countyList: [],
            value: [],
            originalEmail: this.props.dataItem ? this.props.dataItem.Email : '',
            emailMessage: ''
        };
        //console.log(this.state.membershipUserInEdit);
    }

    onDialogInputChange = (event) => {
        let target = event.target;
        //const value = target.type === 'checkbox' ? target.checked : target.value;
        let value;
        // Convert radio button values from string to boolean
        if (target.type === "radio") {
            value = target.value === "true"; // Convert "true" to true and "false" to false
        } else if (target.type === "checkbox") {
            value = target.checked;
        } else {
            value = target.value;
        }

        const name = target.props ? target.props.name : target.name;

        const edited = this.state.membershipUserInEdit;
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            membershipUserInEdit: edited
        });
    };

    handleStateChange = (event) => {
        var selectedState = event.target.value;
        //console.log(selectedState);
        //debugger

        let target = event.target;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state.membershipUserInEdit;

        edited[name] = event.target.value;
        edited['StateId'] = event.target.value.id;
        edited['State'] = event.target.value.name;
        edited.isActive = true;

        this.setState({
            membershipUserInEdit: edited
        });

        //console.log(this.state.membershipUserInEdit);

        //this.setState({
        //    selectedStateId: selectedState,
        //    selectedCounty: null,
        //    countyList: [],
        //    countyErrorMessage: "At least one county must be selected"
        //})

        //if (this.state.originalName == "") {
        //    axios
        //        .get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${selectedState.id}`, { headers: auth.authHeader() })
        //        .then((response) => {
        //            this.setState({
        //                counties: response.data
        //            })
        //        })
        //        .catch((response) => {
        //            console.log(response);
        //        });
        //}
        //else {
        //    let model = {
        //        SelectedStateId: selectedState.id,
        //        districtId: this.state.districtInEdit.districtId
        //    }
        //    axios
        //        .post(`${ROOT_API_URL}/ManageDistrict/GetCountiesOnEdit`, model, { headers: auth.authHeader() })
        //        .then((response) => {
        //            this.setState({
        //                counties: response.data
        //            })
        //        })
        //        .catch((response) => {
        //            console.log(response);
        //        });
        //}

    };

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.membershipUserInEdit.PortalUserID) {
            this.props.save(this.state.membershipUserInEdit);
            this.props.cancel();
        } else {
            throw new Error('Unable to update membership user, PortalUserID is required.');
        }
    };

    handleAutoAddressChange = address => {
        this.setState({ address });
    };

    handleAutoSelect = (address) => {
        //this.props.getCounties(this.state.state.id);
        //this.setState({ address });
        //this.setAutofillFields(address, this.props.district.counties);


        axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${this.state.membershipUserInEdit.StateObj.id}`)
            .then((response) => {
                //this.props.setCounties(response.data);

                this.setState({
                    address,
                    countyList: response.data
                });
                this.setAutofillFields(address, response.data);
            })
            .catch((response) => {
                console.log(response);
            });
    };

    fetchCountiesByStateId = async (id) => {
        return await axios.get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${id}`).then((response) => {
            this.setState({
                countyList: response.data
            });
        });
    }

    setCountyAsync = async (stateId, county) => {
        await this.fetchCountiesByStateId(stateId);

        var countyLst = this.state.countyList;
        var cpMembershipUserInEdit = this.state.membershipUserInEdit;

        countyLst.forEach(countyObj => {
            if (county.includes(countyObj.countyName)) {
                cpMembershipUserInEdit.CountyObj = countyObj;
                this.setState({
                    membershipUserInEdit: cpMembershipUserInEdit
                })
            }
        });
    }

    SetTopSuggestion = suggestions => {

        if (!_.isEqual(this.state.TopSuggestion, suggestions[0])) {
            this.setState({ TopSuggestion: suggestions[0] })
            this.setAutofillFields(suggestions[0].description);
        }
    }

    setAutofillFields = (address, countiesList) => {

        geocodeByAddress(address)
            .then(results => {

                results.map((addressResults) => {
                    var mailingInformation = {
                        ...this.state.membershipUserInEdit,
                        Address1: "",
                        City: "",
                        StateObj: {
                            id: 0,
                            name: ''
                        },
                        CountyObj: { countyId: 0, countyName: "" },
                        Zip: ""
                    }
                    addressResults.address_components.map((result) => {
                        if (result.types.includes("street_number")) {
                            mailingInformation.Address1 = result["short_name"];
                        }
                        if (result.types.includes("route")) {
                            mailingInformation.Address1 = mailingInformation.Address1 + " " + result["short_name"];
                        }
                        if (result.types.includes("locality")) {
                            mailingInformation.City = result["short_name"];
                        }
                        if (result.types.includes("administrative_area_level_1")) {
                            //mailingInformation.state = result["short_name"];

                            var stateObj = this.props.states.find((stateObj) => {
                                if (stateObj.name === result["short_name"].toString()) {
                                    return stateObj
                                }
                            });

                            if (stateObj) {

                                mailingInformation.StateObj = stateObj;

                            }

                        }
                        if (result.types.includes("administrative_area_level_2")) {
                            mailingInformation.CountyObj = result["long_name"];
                        }
                        if (result.types.includes("postal_code")) {
                            mailingInformation.Zip = result["short_name"];
                        }
                    });

                    //this.props.getCounties(mailingInformation.StateObject.id);
                    this.setState({ membershipUserInEdit: mailingInformation });

                })

            }).then(() => {
                //this.selectCounty(this.state.County);
                this.setCountyAsync(this.state.membershipUserInEdit.StateObj.id, this.state.membershipUserInEdit.CountyObj);
            });
    }

    render() {
        return (
            <div className="popupMembershipForm">
                {<h2>Edit User Details</h2>}
                <form className="user-form membership-form" onSubmit={this.handleSubmit}>
                    <div className="form-group col-md-6">
                        <label htmlFor="FirstName">First Name</label>
                        <Input
                            required={true}
                            type="text"
                            name="FirstName"
                            value={this.state.membershipUserInEdit.FirstName || ''}
                            onChange={this.onDialogInputChange}
                            id="FirstName"
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="LastName">Last Name</label>
                        <Input
                            required={true}
                            type="text"
                            name="LastName"
                            id="LastName"
                            value={this.state.membershipUserInEdit.LastName || ''}
                            onChange={this.onDialogInputChange}
                        />
                    </div>
                    <div className="form-group col-md-12">
                        <label htmlFor="Email">Email</label>
                        <Input
                            required={true}
                            type="email"
                            name="Email"
                            id="Email"
                            value={this.state.membershipUserInEdit.Email || ''}
                            onChange={this.onDialogInputChange}
                        />
                        <p className="error-message">{this.state.emailMessage}</p>
                    </div>
                    <label htmlFor="lookupAddrField" style={{ paddingTop: '10px', paddingBottom: '0px', paddingLeft: '5px', paddingRight: '5px', marginBottom: '5px', verticalAlign: 'top' }}>Lookup Address</label>                    <PlacesAutocomplete
                        value={this.state.address || ""}
                        onChange={this.handleAutoAddressChange}
                        onSelect={this.handleAutoSelect}
                    >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                            <div className="col-md-12" id="lookupAddrField" style={{ paddingTop: '0px', paddingBottom: '0px', paddingLeft: '5px', paddingRight: '5px', marginBottom: '5px', verticalAlign: 'top' }}>
                                <input style={{ width: "100%" }}
                                    {...getInputProps({
                                        placeholder: 'Search Places...'
                                    })}
                                />
                                <div style={{ width: "100%" }}>
                                    {loading && <div><p>Loading...</p></div>}
                                    {suggestions.length > 0 ? this.SetTopSuggestion(suggestions)
                                        : ""}
                                    {suggestions.map(suggestion => {
                                        const className = suggestion.active
                                            ? 'suggestion-item--active'
                                            : 'suggestion-item';
                                        // inline style for demonstration purpose
                                        const style = suggestion.active
                                            ? {
                                                backgroundColor: '#f0f0f0',
                                                cursor: 'pointer',
                                                width: '100%'
                                            }
                                            : {
                                                backgroundColor: '#ffffff',
                                                cursor: 'pointer',
                                                width: '100%'
                                            };
                                        return (
                                            <div
                                                {...getSuggestionItemProps(suggestion, {
                                                    className,
                                                    style,
                                                })}
                                            >
                                                <span>{suggestion.description}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </PlacesAutocomplete>
                    <div className="mailingAddressContainer">
                        <div className="address1-wrapper form-group col-md-6 col-lg-6">
                            <label htmlFor="Address1">Address 1</label>
                            <Input
                                id="Address1"
                                type="text"
                                value={this.state.membershipUserInEdit.Address1 || ''}
                                onChange={this.onDialogInputChange}
                                name="Address1"
                            />
                        </div>
                        <div className="address2-wrapper form-group col-md-6 col-lg-6">
                            <label htmlFor="Address2">Address 2</label>
                            <Input
                                id="Address2"
                                type="text"
                                value={this.state.membershipUserInEdit.Address2 || ''}
                                onChange={this.onDialogInputChange}
                                name="Address2"
                            />
                        </div>
                        <div className="city-wrapper form-group col-md-6 col-lg-6">
                            <label htmlFor="City">City</label>
                            <Input
                                id="City"
                                type="text"
                                value={this.state.membershipUserInEdit.City || ''}
                                onChange={this.onDialogInputChange}
                                name="City"
                            />
                        </div>
                        <div className="state-wrapper form-group col-md-6 col-lg-6">
                            <label htmlFor="State">State</label>
                            <DropDownList data={this.props.states}
                                textField="name"
                                defaultItem={this.state.membershipUserInEdit.StateObj}
                                dataItemKey="id"
                                onChange={this.handleStateChange}
                                required={true}
                                value={this.state.membershipUserInEdit.StateObj}
                                id="StateObj"
                                name="StateObj"
                            />
                        </div>
                        <div className="zip-wrapper form-group col-md-6 col-lg-6">
                            <label htmlFor="Zip">Zip</label>
                            <Input
                                id="Zip"
                                validityStyles={false}
                                value={this.state.membershipUserInEdit.Zip || ''}
                                onChange={this.onDialogInputChange}
                                name="Zip"
                                pattern="(\d{5}([\-]\d{4})?)"
                                type="text"
                                placeholder="12345"
                                title="Zip Code (Format: 12345 or 12345-6789)"
                            />
                        </div>
                        <div className="form-group col-md-6 col-lg-6">
                            <label htmlFor="Phone">Phone</label>
                            <Input
                                type="text"
                                name="Phone"
                                id="Phone"
                                value={this.state.membershipUserInEdit.Phone || ''}
                                onChange={this.onDialogInputChange}
                            />
                        </div>
                        <div className="form-group col-md-6 isLockedOut  d-flex align-items-center">
                            <label className="mb-0 mr-4 w-auto d-inline-block">Locked</label>
                            <div className="d-flex mt-2">
                                <label htmlFor="IsLockedOutYes" className="mr-2 d-flex align-items-center">
                                    <input
                                        type="radio"
                                        id="IsLockedOutYes"
                                        name="IsLockedOut"
                                        value="true"
                                        checked={this.state.membershipUserInEdit.IsLockedOut === true}
                                        onChange={this.onDialogInputChange}
                                        className="custom-control-input"
                                    />
                                    <span className={this.state.membershipUserInEdit.IsLockedOut === true ? "fas fa-check-circle" : "far fa-circle"}></span>
                                    <span className="ml-1">Yes</span>
                                </label>
                                <label htmlFor="IsLockedOutNo" className="d-flex align-items-center">
                                    <input
                                        type="radio"
                                        id="IsLockedOutNo"
                                        name="IsLockedOut"
                                        value="false"
                                        checked={this.state.membershipUserInEdit.IsLockedOut === false}
                                        onChange={this.onDialogInputChange}
                                        className="custom-control-input"
                                    />
                                    <span className={this.state.membershipUserInEdit.IsLockedOut === false ? "fas fa-check-circle" : "far fa-circle"}></span>
                                    <span className="ml-1">No</span>
                                </label>
                            </div>
                        </div>

                    </div>
                    <div className="footer">
                        <div className="form-group">
                            <button className="admin-k-button" onClick={this.props.cancel}>
                                <i className="fas fa-times"></i>
                                <span>CANCEL</span>
                            </button>
                            <button type="submit" className="admin-k-button">
                                <i className="fas fa-edit"></i>
                                <span>UPDATE</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default UserMembershipForm;